import { render, staticRenderFns } from "./AreaDoAssociado.vue?vue&type=template&id=c4e5bb50&"
import script from "./AreaDoAssociado.vue?vue&type=script&lang=js&"
export * from "./AreaDoAssociado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports